<template>
    <div class="template-base">
        <Header Title="Reporting" :iconPath="'/images/icons/report.png'" class="div-header" />
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit" />
            <!-- TODO:ReportEmailer -->
            <!-- <Button v-if="portalUser.isAdmin || portalUser.isAdminPlus" class="x-smaller-button" :buttonModel="btnEmailer" @on-clicked="showScheduler = true" />         -->
        </div>
        <div class="div-body" style="overflow-y: auto;overflow-x: hidden;margin:10px;">
            <div class="setting-header-label">Daily Dashboard</div>
            <div class="setting-header-bar"><hr class="header-divider" /></div>
            <div class="report-cards-container">
                <KPI :title="'Total Income'" :type="'currency'" ref="kpiTotalIncome" />
                <KPI :title="'Income from ' + (portalUser.enablePos ? 'Point of Sale' : 'Cashier')" :type="'currency'" ref="kpiIncomeFromCashiers" />
                <KPI :title="'Income from Dispensers'" :type="'currency'" ref="kpiIncomeFromDispensers" />
                <KPI :title="'Income from Mobile App'" :type="'currency'" ref="kpiIncomeFromMobileApp" />
                <KPI :title="'Income from Mobile Tee-Box'" :type="'currency'" ref="kpiIncomeFromMobileTBox" />
                <KPI :title="'Income from Mobile Pincode'" :type="'currency'" ref="kpiIncomeFromMobilePincode" />
                <KPI :title="'Income from Web Sales'" :type="'currency'" ref="kpiIncomeFromWebSales" />
            </div>
            <div class="report-cards-container">
                <KPI :title="'Credits Purchased'" :type="'credit'" ref="kpiCreditsPurchased" />
                <KPI :title="'Credits Used'" :type="'credit'" ref="kpiCreditsUsed" />
                <KPI :title="'Balls Dispensed'" :type="'numeric'" ref="kpiBallsDispensed" />
                <KPI :title="'Outstanding Pin Codes'" :type="'numeric'" ref="kpiIOutStandingPinCodes" />
            </div>

            <div class="setting-header-label">Reports</div>
            <div class="setting-header-bar"><hr class="header-divider"/></div>
            <div class="report-listing">
                <div class="report-section-group">
                    <div class="report-section-title">Summaries</div>
                    
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewSummaryReport = true">Summary Report</a>
                        <div class="report-page-description">Totals in system</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>
                    
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewCashierSalesReport = true">Cashier Sales Report</a>
                        <div class="report-page-description">Sales from cashier</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewDispenserSalesReport = true">Dispenser Sales Report</a>
                        <div class="report-page-description">Sales from dispenser stations</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>    

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewMobileAppSalesReport = true">Mobile App Sales Report</a>
                        <div class="report-page-description">Sales through mobile app</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>
                    
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewWebSalesReport = true">Web Sales Report</a>
                        <div class="report-page-description">Sales through web links</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>
                                        
                    <div class="report-section" v-if="portalUser.enableSubscriptions">
                        <a class="button-link report-button-link" @click="viewSubscriptionSalesReport = true">Subscription Sales Report</a>
                        <div class="report-page-description">Sales from subscription</div>
                    </div>

                    <!-- For Future -->
                    <div class="report-section" v-if="false">
                        <a class="button-link report-button-link" @click="viewVendorSalesReport = true">Vendor Sales Report</a>
                        <div class="report-page-description">Sales through 3rd party vendor integration</div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTotalsByCardTypes = true">Totals by All Card Types</a>
                        <div class="report-page-description">Sales by all card types</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTotalsByCreditCardTypes = true">Totals by Credit Card Types</a>
                        <div class="report-page-description">Sales by credit card types only</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTotalsByBucketSize = true">Totals by Bucket Size</a>
                        <div class="report-page-description">Total bucket sales</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTotalsByStations = true">Totals by Stations</a>
                        <div class="report-page-description">Sales by each dispenser station</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewDispenserSummary = true">Dispenser Summary</a>
                        <div class="report-page-description">Summary of each dispenser station</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>
                </div>

                <div class="report-section-group">
                    <div class="report-section-title">Logs</div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewCashierAuditTrail = true">Cashier Audit Trail</a>
                        <div class="report-page-description">Cashier activities</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewCardReaderLogs = true">Card Logs</a>
                        <div class="report-page-description">Credit card and member card activities</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewCreditCardVoids = true">Credit Card Voids and Refunds</a>
                        <div class="report-page-description">Credit card voids and refunds</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewMemberPurchases = true">Member Purchases</a>
                        <div class="report-page-description">Purchases made by members</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTransactionActivity = true">Transaction Activity</a>
                        <div class="report-page-description">Transaction Activities in the system</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewEndOfShift = true">End of Shift</a>
                        <div class="report-page-description">End of shift report for user session</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="onGiftCardBalances">Gift Card Balances</a>
                        <div class="report-page-description">Gift card balances</div>                        
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewIncomeReport = true">Income Logs</a>
                        <div class="report-page-description">Log of the income transactions</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewGeneralLedgerTotals = true">General Ledger Totals</a>
                        <div class="report-page-description">Shows the total sales of each general ledger item</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewQuickbooks = true">QuickBooks Export</a>
                        <div class="report-page-description">Generate export for QuickBooks</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewMemberCategoryUsage = true">Member Category Usage</a>
                        <div class="report-page-description">Log of members using a category</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section" v-if="portalUser.isAdminPlus">
                        <a class="button-link report-button-link" @click="viewOrderTransactions = true">Order Transactions</a>
                        <div class="report-page-description">View all order attempts</div>
                    </div>
                </div>

                <div class="report-section-group">
                    <div class="report-section-title">Charts</div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTakingbyCashier = true">Taking by Cashier</a>
                        <div class="report-page-description">Takings by each cashier</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>

                    <div class="report-section">                        
                        <a class="button-link report-button-link" @click="viewBallsDispensedbyDayofMonth = true">Balls Dispensed</a>
                        <a class="button-link report-button-link" @click="viewMinutesUsedbyDayofMonth = true" style="margin-left:14px">Minutes Used</a>
                        <div class="report-page-description">Charts by the day of month</div>
                        <div class="report-page-email-schedule-container" v-if="false">
                            <img :src="'/images/icons/scheduler-email.png'" alt="Report" width="16" height="16">
                            <label class="report-page-email-option"><input type="checkbox"> PDF</label>
                            <label class="report-page-email-option"><input type="checkbox"> CSV</label>
                        </div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewBallsDispensedbyDayofWeek = true">Balls Dispensed</a>
                        <a class="button-link report-button-link" @click="viewMinutesUsedbyDayofWeek = true" style="margin-left:14px">Minutes Used</a>
                        <div class="report-page-description">Charts by the day of week</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewBallsDispensedbyHour = true">Balls Dispensed</a>
                        <a class="button-link report-button-link" @click="viewMinutesUsedbyHour = true" style="margin-left:14px">Minutes Used</a>
                        <div class="report-page-description">Charts by hour</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewBallsDispensedbyStation = true">Balls Dispensed</a>
                        <a class="button-link report-button-link" @click="viewMinutesUsedbyStation = true" style="margin-left:14px">Minutes Used</a>
                        <div class="report-page-description">Charts by ball machine station</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewBallsDispensedbySource = true">Balls Dispensed</a>
                        <a class="button-link report-button-link" @click="viewMinutesUsedbySource = true" style="margin-left:14px">Minutes Used</a>
                        <div class="report-page-description">Charts by source</div>
                    </div>

                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewBucketsDispensedbySource = true">Balls Dispensed</a>
                        <a class="button-link report-button-link" @click="viewMinutesUsedbySource2 = true" style="margin-left:14px">Minutes Used</a>
                        <div class="report-page-description">Charts by source per size</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewBucketSalesbySource = true">Buckets</a>
                        <a class="button-link report-button-link" @click="viewMinutesSalesbySource = true" style="margin-left:14px">Time</a>
                        <div class="report-page-description">Sales collected by source for each size</div>
                    </div>
                </div>

                <div class="report-section-group" v-if="portalUser.enablePos">
                    <div class="report-section-title">Point of Sale</div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewSalesActivityReport = true">Sales Activity Report</a>
                        <div class="report-page-description">Sales activity at Point of sale</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewSalesReport = true">Sales Report</a>
                        <div class="report-page-description">Items sold at Point of sale</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewTerminalCashFlowReport = true">Terminal Cash Flow</a>
                        <div class="report-page-description">The cash flow at the point of sale terminals</div>
                    </div>
                    <div class="report-section">
                        <a class="button-link report-button-link" @click="viewCashierCashTakingsReport = true">Cashier Cash Takings</a>
                        <div class="report-page-description">Total cash received by cashier</div>
                    </div>
                    <div class="report-section" v-if="portalUser.enableInventoryManagement">
                        <a class="button-link report-button-link" @click="onInventoryBalance">Inventory Balances</a>
                        <div class="report-page-description">Export of current inventory balances</div>
                    </div>
                    <div class="report-section" v-if="portalUser.enableInventoryManagement">
                        <a class="button-link report-button-link" @click="viewInventoryReceiving = true">Inventory Receiving</a>
                        <div class="report-page-description">Log of inventory items received</div>
                    </div>
                </div>                
            </div>
            <div>
                <ReportSummary style="width:100%" v-show="viewSummaryReport" @on-close="onClose" />
                <ReportSalesCashier style="width:100%" v-show="viewCashierSalesReport" @on-close="onClose" />
                <ReportSalesDispenser style="width:100%" v-show="viewDispenserSalesReport" @on-close="onClose" />
                <ReportSalesVendor style="width:100%" v-show="viewVendorSalesReport" @on-close="onClose" />
                <ReportSalesMobileApp style="width:100%" v-show="viewMobileAppSalesReport" @on-close="onClose" />
                <ReportSalesWeb style="width:100%" v-show="viewWebSalesReport" @on-close="onClose" />
                <ReportSalesSubscriptions style="width:100%" v-show="viewSubscriptionSalesReport" @on-close="onClose" />
                <ReportTotalsByCardType style="width:100%" v-show="viewTotalsByCardTypes" @on-close="onClose" :creditCardsOnly="false" />
                <ReportTotalsByCardType style="width:100%" v-show="viewTotalsByCreditCardTypes" @on-close="onClose" :creditCardsOnly="true" />
                <ReportTotalsByBucketSize style="width:100%" v-show="viewTotalsByBucketSize" @on-close="onClose" />
                <ReportTotalsByStation style="width:100%" v-show="viewTotalsByStations" @on-close="onClose" />
                <ReportCashierAuditTrail style="width:100%" v-show="viewCashierAuditTrail" @on-close="onClose" />
                <ReportCardReaderLogs style="width:100%" v-show="viewCardReaderLogs" @on-close="onClose" />
                <ReportCreditCardVoidLogs style="width:100%" v-show="viewCreditCardVoids" @on-close="onClose" />
                <ReportBallsDispensedByHour style="width:100%" v-show="viewBallsDispensedbyHour" @on-close="onClose" :getMinutes="false"/>
                <ReportBallsDispensedByHour style="width:100%" v-show="viewMinutesUsedbyHour" @on-close="onClose" :getMinutes="true"/>
                <ReportBallsDispensedByDayOfMonth style="width:100%" v-show="viewBallsDispensedbyDayofMonth" @on-close="onClose" :getMinutes="false"/>
                <ReportBallsDispensedByDayOfMonth style="width:100%" v-show="viewMinutesUsedbyDayofMonth" @on-close="onClose" :getMinutes="true"/>
                <ReportBallsDispensedByDayOfWeek style="width:100%" v-show="viewBallsDispensedbyDayofWeek" @on-close="onClose" :getMinutes="false"/>
                <ReportBallsDispensedByDayOfWeek style="width:100%" v-show="viewMinutesUsedbyDayofWeek" @on-close="onClose" :getMinutes="true"/>
                <ReportTakingsByCashier style="width:100%" v-show="viewTakingbyCashier" @on-close="onClose" />
                <ReportBallsDispensedbyStation style="width:100%" v-show="viewBallsDispensedbyStation" @on-close="onClose" :getMinutes="false"/>
                <ReportBallsDispensedbyStation style="width:100%" v-show="viewMinutesUsedbyStation" @on-close="onClose" :getMinutes="true"/>
                <ReportBallsDispensedBySource style="width:100%" v-show="viewBallsDispensedbySource" @on-close="onClose" :getMinutes="false"/>
                <ReportBallsDispensedBySource style="width:100%" v-show="viewMinutesUsedbySource" @on-close="onClose" :getMinutes="true"/>
                <ReportBucketDispensedBySource style="width:100%" v-show="viewBucketsDispensedbySource" @on-close="onClose" :getMinutes="false"/>
                <ReportBucketDispensedBySource style="width:100%" v-show="viewMinutesUsedbySource2" @on-close="onClose" :getMinutes="true"/>
                <ReportBucketSalesBySource style="width:100%" v-show="viewBucketSalesbySource" @on-close="onClose" :getMinutes="false" />
                <ReportBucketSalesBySource style="width:100%" v-show="viewMinutesSalesbySource" @on-close="onClose" :getMinutes="true" />
                <ReportMemberPurchases style="width:100%" v-show="viewMemberPurchases" @on-close="onClose" />
                <ReportDispenserSummary style="width:100%" v-show="viewDispenserSummary" @on-close="onClose" />
                <ReportTransactionActivity style="width:100%" v-show="viewTransactionActivity" @on-close="onClose" />
                <ReportEndOfShift style="width:100%" v-show="viewEndOfShift" @on-close="onClose" :showCurrentSession="false" />
                <ReportSales style="width:100%" v-show="viewSalesReport" @on-close="onClose" :showCurrentSession="false" />
                <ReportSalesActivity style="width:100%" v-show="viewSalesActivityReport" @on-close="onClose" :showCurrentSession="false" />
                <ReportGeneralLedgerTotals style="width:100%" v-show="viewGeneralLedgerTotals" @on-close="onClose" :showCurrentSession="false" />
                <ReportInventoryReceiving style="width:100%" v-show="viewInventoryReceiving" @on-close="onClose" :showCurrentSession="false" />
                <ReportTerminalCashFlow style="width:100%" v-show="viewTerminalCashFlowReport" @on-close="onClose" />
                <ReportCashierCashTakings style="width:100%" v-show="viewCashierCashTakingsReport" @on-close="onClose" />
                <ReportIncomeLogs style="width:100%" v-show="viewIncomeReport" @on-close="onClose" />
                <ReportInventoryBalances style="width:100%" v-show="viewInventoryBalance" @on-close="onClose" :showCurrentSession="false" ref="refInventoryBalance" />
                <ReportGiftCardBalances style="width:100%" v-show="viewGiftCardBalances" @on-close="onClose" :showCurrentSession="false" ref="refGiftCardBalances" />
                <ReportQuickbooks style="width:100%" v-show="viewQuickbooks" @on-close="onClose" :showCurrentSession="false" />
                <ReportMemberCategoryUsage style="width:100%" v-show="viewMemberCategoryUsage" @on-close="onClose" :showCurrentSession="false" />
                <ReportOrderTransactions style="width:100%" v-show="viewOrderTransactions" @on-close="onClose" :showCurrentSession="false" />
                <ReportEmailerConfig style="width:100%" v-if="showScheduler" @on-cancel="showScheduler = false" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import apiReport from "@/api/apiReport";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import PortalUserModel from "@/common/models/PortalUserModel";

import KPI from "@/views/components/Reports/KPI.vue";
import ReportSummary from "@/views/components/Reports/ReportSummary.vue";

import ReportSalesCashier from "@/views/components/Reports/ReportSalesCashier.vue";
import ReportSalesDispenser from "@/views/components/Reports/ReportSalesDispenser.vue";
import ReportSalesVendor from "@/views/components/Reports/ReportSalesVendor.vue";
import ReportSalesMobileApp from "@/views/components/Reports/ReportSalesMobileApp.vue";
import ReportSalesWeb from "@/views/components/Reports/ReportSalesWeb.vue";
import ReportSalesSubscriptions from "@/views/components/Reports/ReportSalesSubscriptions.vue";
import ReportTotalsByCardType from "@/views/components/Reports/ReportTotalsByCardType.vue";
import ReportTotalsByBucketSize from "@/views/components/Reports/ReportTotalsByBucketSize.vue";
import ReportTotalsByStation from "@/views/components/Reports/ReportTotalsByStation.vue";
import ReportCashierAuditTrail from "@/views/components/Reports/ReportCashierAuditTrail.vue";
import ReportCardReaderLogs from "@/views/components/Reports/ReportCardReaderLogs.vue";
import ReportCreditCardVoidLogs from "@/views/components/Reports/ReportCreditCardVoidLogs.vue";
import ReportBallsDispensedByHour from "@/views/components/Reports/ReportBallsDispensedByHour.vue";
import ReportBallsDispensedByDayOfMonth from "@/views/components/Reports/ReportBallsDispensedByDayOfMonth.vue";
import ReportBallsDispensedByDayOfWeek from "@/views/components/Reports/ReportBallsDispensedByDayOfWeek.vue";
import ReportTakingsByCashier from "@/views/components/Reports/ReportTakingsByCashier.vue";
import ReportBallsDispensedbyStation from "@/views/components/Reports/ReportBallsDispensedByStation.vue";
import ReportBallsDispensedBySource from "@/views/components/Reports/ReportBallsDispensedBySource.vue";
import ReportBucketDispensedBySource from "@/views/components/Reports/ReportBucketDispensedBySource.vue";
import ReportBucketSalesBySource from "@/views/components/Reports/ReportBucketSalesBySource.vue";
import ReportEndOfShift from "@/views/components/Reports/ReportEndOfShift.vue";
import ReportMemberPurchases from "@/views/components/Reports/ReportMemberPurchases.vue";
import ReportDispenserSummary from "@/views/components/Reports/ReportDispenserSummary.vue";
import ReportTransactionActivity from "@/views/components/Reports/ReportTransactionActivity.vue";
import ReportGiftCardBalances from "@/views/components/Reports/ReportGiftCardBalances.vue";
import ReportTerminalCashFlow from "@/views/components/Reports/ReportTerminalCashFlow.vue";
import ReportInventoryBalances from "@/views/components/Reports/ReportInventoryBalances.vue";
import ReportSales from "@/views/components/Reports/ReportSales.vue";
import ReportIncomeLogs from "@/views/components/Reports/ReportIncomeLogs.vue";
import ReportGeneralLedgerTotals from "@/views/components/Reports/ReportGeneralLedgerTotals.vue";
import ReportInventoryReceiving from "@/views/components/Reports/ReportInventoryReceiving.vue";
import ReportCashierCashTakings from "@/views/components/Reports/ReportCashierCashTakings.vue";
import ReportSalesActivity from "@/views/components/Reports/ReportSalesActivity.vue";
import ReportQuickbooks from "@/views/components/Reports/ReportQuickbooks.vue";
import ReportMemberCategoryUsage from "@/views/components/Reports/ReportMemberCategoryUsage.vue";
import ReportOrderTransactions from "@/views/components/Reports/ReportOrderTransactions.vue";
import ReportEmailerConfig from "@/views/components/Administrator/ReportEmailerConfig.vue";

export default {
    components: {
        Header,
        Button,
        ReportEmailerConfig,
        KPI,
        ReportSummary,
        ReportSalesCashier,
        ReportSalesDispenser,
        ReportSalesVendor,
        ReportSalesMobileApp,
        ReportSalesWeb,
        ReportSalesSubscriptions,
        ReportTotalsByCardType,
        ReportTotalsByBucketSize,
        ReportTotalsByStation,
        ReportCashierAuditTrail,
        ReportCardReaderLogs,
        ReportCreditCardVoidLogs,
        ReportBallsDispensedByHour,
        ReportBallsDispensedByDayOfMonth,
        ReportBallsDispensedByDayOfWeek,
        ReportTakingsByCashier,
        ReportBallsDispensedbyStation,
        ReportBallsDispensedBySource,
        ReportBucketDispensedBySource,
        ReportBucketSalesBySource,
        ReportEndOfShift,
        ReportMemberPurchases,
        ReportDispenserSummary,
        ReportTransactionActivity,
        ReportInventoryBalances,
        ReportSales,
        ReportGiftCardBalances,
        ReportTerminalCashFlow,
        ReportIncomeLogs,
        ReportGeneralLedgerTotals,
        ReportInventoryReceiving,
        ReportCashierCashTakings,
        ReportSalesActivity,
        ReportQuickbooks,
        ReportMemberCategoryUsage,
        ReportOrderTransactions
    },
    setup() {
        var portalUser = PortalUserModel.fromToken();

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnEmailer = ButtonModel.CreateClick("");
        btnEmailer.iconPath = "/images/icons/scheduler-email.png";
        btnEmailer.title = "Config report emails...";

        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);
        const showScheduler = ref(false);

        const kpiTotalIncome = ref(null);
        const kpiIncomeFromCashiers = ref(null);
        const kpiIncomeFromDispensers = ref(null);
        const kpiIncomeFromMobileApp = ref(null);
        const kpiIncomeFromMobileTBox = ref(null);
        const kpiIncomeFromMobilePincode = ref(null);
        const kpiIncomeFromWebSales = ref(null);
        const kpiCreditsPurchased = ref(null);
        const kpiCreditsUsed = ref(null);
        const kpiBallsDispensed = ref(null);
        const kpiIOutStandingPinCodes = ref(null);        

        onMounted(async () => {
            try {
                fetchingData.value = true;
                emitter.emit("server-call-start", "Loading...");

                var data = await apiReport.summary(new Date().addDays(-6).toSiteDateTimeWithFormat("YYYY-MM-DDT12:00"), new Date().toSiteDateTimeWithFormat("YYYY-MM-DDT12:00"), 1, true);

                if (portalUser.enablePos) {
                    kpiTotalIncome.value.loadData(
                        data.map(
                            (data) =>                                                                
                                // Income from Pos
                                data.incomeFromPosCash +
                                data.incomeFromPosCreditCard +

                                // Income from Dispenser
                                data.bucketPurchaseCash +
                                data.bucketPurchaseCreditCards +
                                data.bucketPurchaseRangeCardReloads + 
                                data.bucketPurchaseCreditCardsRefund +                               

                                // Income from Mobile App
                                data.incomeFromMobileReloads +
                                data.incomeFromMobileReloadsRefund +
                                
                                // Income from Web Sales
                                data.incomeFromWebSalesPincodes +
                                data.incomeFromWebSalesPincodesRefund
                                
                                
                        )
                    );
                } else {
                    // TODO
                    kpiTotalIncome.value.loadData(
                    data.map(
                        (data) =>
                                // Income from Pos
                                data.incomeFromPosCash +
                                data.incomeFromPosCreditCard +

                                // Income from Dispenser
                                data.bucketPurchaseCash +
                                data.bucketPurchaseCreditCards +
                                data.bucketPurchaseRangeCardReloads +
                                data.bucketPurchaseCreditCardsRefund +

                                // Income from Mobile App
                                data.incomeFromMobileReloads +
                                data.incomeFromMobileReloadsRefund +
                                
                                // Income from Web Sales
                                data.incomeFromWebSalesPincodes +
                                data.incomeFromWebSalesPincodesRefund
                    )
                );
                }
                
                kpiIncomeFromCashiers.value.loadData(data.map((data) => data.manualEntry + data.pinCode + data.rangeCardReloads + data.salesItems + data.doorTurnstile));
                if (portalUser.enablePos) {
                    kpiIncomeFromCashiers.value.loadData(data.map((data) => data.incomeFromPosCash + data.incomeFromPosCreditCard));
                }
                kpiIncomeFromDispensers.value.loadData(data.map((data) => data.bucketPurchaseCash + data.bucketPurchaseCreditCards + data.bucketPurchaseRangeCardReloads));
                kpiIncomeFromMobileApp.value.loadData(data.map((data) => data.incomeFromMobileReloads));
                kpiIncomeFromMobileTBox.value.loadData(data.map((data) => data.incomeFromMobileTBox));
                kpiIncomeFromMobilePincode.value.loadData(data.map((data) => data.incomeFromMobilePincode));
                kpiCreditsPurchased.value.loadData(data.map((data) => data.creditPurchased));
                kpiCreditsUsed.value.loadData(data.map((data) => data.creditUsed));
                kpiBallsDispensed.value.loadData(data.map((data) => data.totalBallsDispensed));
                kpiIOutStandingPinCodes.value.loadData(data.map((data) => data.outstandingPinCode));                
                kpiIncomeFromWebSales.value.loadData(data.map((data) => data.incomeFromWebSalesPincodes));
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        });

        const onClose = () => {
            viewSummaryReport.value = false;
            viewCashierSalesReport.value = false;
            viewDispenserSalesReport.value = false;
            viewVendorSalesReport.value = false;
            viewMobileAppSalesReport.value = false;
            viewWebSalesReport.value = false;
            viewSubscriptionSalesReport.value = false;
            viewTotalsByCardTypes.value = false;
            viewTotalsByCreditCardTypes.value = false;
            viewTotalsByBucketSize.value = false;
            viewTotalsByStations.value = false;
            viewCashierAuditTrail.value = false;
            viewCardReaderLogs.value = false;
            viewCreditCardVoids.value = false;
            viewBallsDispensedbyHour.value = false;
            viewMinutesUsedbyHour.value = false;
            viewBallsDispensedbyDayofMonth.value = false;
            viewMinutesUsedbyDayofMonth.value = false;
            viewBallsDispensedbyDayofWeek.value = false;
            viewMinutesUsedbyDayofWeek.value = false;
            viewTakingbyCashier.value = false;
            viewBallsDispensedbyStation.value = false;
            viewMinutesUsedbyStation.value = false;
            viewBallsDispensedbySource.value = false;
            viewMinutesUsedbySource.value = false;
            viewBucketsDispensedbySource.value = false;
            viewMinutesUsedbySource2.value = false;
            viewBucketSalesbySource.value = false;
            viewMinutesSalesbySource.value = false;
            viewMemberPurchases.value = false;
            viewDispenserSummary.value = false;
            viewTransactionActivity.value = false;
            viewEndOfShift.value = false;
            viewGiftCardBalances.value = false;
            viewTerminalCashFlowReport.value = false;
            viewCashierCashTakingsReport.value = false;
            viewIncomeReport.value = false;
            viewSalesReport.value = false;
            viewSalesActivityReport.value = false;
            viewGeneralLedgerTotals.value = false;
            viewInventoryReceiving.value = false;
            viewInventoryBalance.value = false;
            viewQuickbooks.value = false;
            viewMemberCategoryUsage.value = false;
            viewOrderTransactions.value = false;
        };

        const viewSummaryReport = ref(false);
        const viewCashierSalesReport = ref(false);
        const viewDispenserSalesReport = ref(false);
        const viewVendorSalesReport = ref(false);
        const viewMobileAppSalesReport = ref(false);
        const viewWebSalesReport = ref(false);
        const viewSubscriptionSalesReport = ref(false);
        const viewTotalsByCardTypes = ref(false);
        const viewTotalsByCreditCardTypes = ref(false);
        const viewTotalsByBucketSize = ref(false);
        const viewTotalsByStations = ref(false);
        const viewCashierAuditTrail = ref(false);
        const viewCardReaderLogs = ref(false);
        const viewCreditCardVoids = ref(false);
        const viewBallsDispensedbyHour = ref(false);
        const viewMinutesUsedbyHour = ref(false);
        const viewBallsDispensedbyDayofMonth = ref(false);
        const viewMinutesUsedbyDayofMonth = ref(false);
        const viewBallsDispensedbyDayofWeek = ref(false);
        const viewMinutesUsedbyDayofWeek = ref(false);
        const viewTakingbyCashier = ref(false);
        const viewBallsDispensedbyStation = ref(false);
        const viewMinutesUsedbyStation = ref(false);
        const viewBallsDispensedbySource = ref(false);
        const viewMinutesUsedbySource = ref(false);
        const viewBucketsDispensedbySource = ref(false);
        const viewMinutesUsedbySource2 = ref(false);
        const viewBucketSalesbySource = ref(false);
        const viewMinutesSalesbySource = ref(false);
        const viewEndOfShift = ref(false);
        const viewMemberPurchases = ref(false);
        const viewDispenserSummary = ref(false);
        const viewTransactionActivity = ref(false);
        const viewGiftCardBalances = ref(false);
        const viewTerminalCashFlowReport = ref(false);
        const viewCashierCashTakingsReport = ref(false);
        const viewIncomeReport = ref(false);
        const viewSalesReport = ref(false);
        const viewSalesActivityReport = ref(false);
        const viewGeneralLedgerTotals = ref(false);
        const viewInventoryReceiving = ref(false);
        const viewInventoryBalance = ref(false);
        const viewQuickbooks = ref(false);
        const viewMemberCategoryUsage = ref(false);
        const viewOrderTransactions = ref(false);

        const refInventoryBalance = ref(null);
        const onInventoryBalance = async () => {
            await refInventoryBalance.value.onView();
            viewInventoryBalance.value = true;
        };

        const refGiftCardBalances = ref(null);
        const onGiftCardBalances = async () => {
            await refGiftCardBalances.value.onView();
            viewGiftCardBalances.value = true;
        };        
                

        return {
            btnExit,
            btnEmailer,
            onClose,
            portalUser,            
            showScheduler,

            refInventoryBalance,
            onInventoryBalance,
            refGiftCardBalances,
            onGiftCardBalances,

            kpiTotalIncome,
            kpiIncomeFromCashiers,
            kpiIncomeFromDispensers,
            kpiIncomeFromMobileApp,
            kpiIncomeFromMobileTBox,
            kpiIncomeFromMobilePincode,
            kpiIncomeFromWebSales,
            kpiCreditsPurchased,
            kpiCreditsUsed,
            kpiBallsDispensed,
            kpiIOutStandingPinCodes,

            viewSummaryReport,
            viewCashierSalesReport,
            viewDispenserSalesReport,
            viewVendorSalesReport,
            viewMobileAppSalesReport,
            viewWebSalesReport,
            viewSubscriptionSalesReport,
            viewTotalsByCardTypes,
            viewTotalsByCreditCardTypes,
            viewTotalsByBucketSize,
            viewTotalsByStations,
            viewCashierAuditTrail,
            viewCardReaderLogs,
            viewCreditCardVoids,
            viewBallsDispensedbyHour,
            viewMinutesUsedbyHour,
            viewBallsDispensedbyDayofMonth,
            viewMinutesUsedbyDayofMonth,
            viewBallsDispensedbyDayofWeek,
            viewMinutesUsedbyDayofWeek,
            viewTakingbyCashier,
            viewBallsDispensedbyStation,
            viewMinutesUsedbyStation,
            viewBallsDispensedbySource,
            viewMinutesUsedbySource,
            viewBucketsDispensedbySource,
            viewMinutesUsedbySource2,
            viewBucketSalesbySource,
            viewMinutesSalesbySource,
            viewMemberPurchases,
            viewDispenserSummary,
            viewTransactionActivity,
            viewEndOfShift,

            viewGiftCardBalances,
            viewSalesReport,
            viewSalesActivityReport,
            viewGeneralLedgerTotals,
            viewInventoryReceiving,
            viewTerminalCashFlowReport,
            viewCashierCashTakingsReport,
            viewIncomeReport,
            viewInventoryBalance,
            viewQuickbooks,        
            viewMemberCategoryUsage,
            viewOrderTransactions,        
        };
    }
};
</script>

<style>
.report-cards-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.report-listing {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.report-section-group {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 20px;
}

.report-section {
    margin-top: 20px;
}

.report-button-link {
    font-size: 11pt;
}

.report-page-description {
    color: black;
    font-size: 11pt;
    /* margin-top: 10px; */
}

.report-section-title {
    margin-top: 20px;
    font-size: 11pt;
    color: black;
    text-transform: uppercase;
}

.report-page-email-schedule-container {
    display:flex; 
    align-items:center; 
    gap:10px;
    font-size: 8pt; 
    margin-top: 10px;
}

.report-page-email-option {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

</style>
